import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { HisUiService } from '../../../../../../core/service/base/his-ui.service';
import { resourcePropertyMap } from '../../../model/his-resource-property-display.model';
import { ResourcePropertyDetail } from '../../../model/resource-property-detail.model';
import { signedPdfFeedback } from './signed-pdf-feedback';

/**
 * Shows the signature state of a PDF as a status icon next to the filename; the feedback
 * itself is presented in an overlay opened from that icon.
 *
 * This is the Angular counterpart of the {@code signedPdfResource} fragment of the JSF
 * {@code selectFile-metadata-icon.xhtml}.
 */
@Component( {
    standalone: false,
    selector: 'his-signed-pdf-resource-icon',
    templateUrl: './his-signed-pdf-resource-icon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './his-signed-pdf-resource-icon.component.css',
} )
export class HisSignedPdfResourceIconComponent {

    /** The properties of the {@code signedPdfResource} category of the file. */
    readonly details = input.required<ResourcePropertyDetail[]>();

    private readonly hisUiService = inject( HisUiService );

    protected readonly feedback = computed( () => signedPdfFeedback(
        resourcePropertyMap( this.details() ),
        ( key, ...params ) => this.hisUiService.translate( key, ...params )
    ) );
}
